import { c as _c } from "react/compiler-runtime";
import { palette } from '../../../theme';
import { Box, Typography } from '@mui/material';
import type { ProsAndConsListProps } from '../types';
export function ProsAndConsList(t0) {
  const $ = _c(13);
  const {
    title,
    listItems
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: "flex",
      flexDirection: "column",
      gap: 3,
      flex: {
        xs: "unset",
        sm: 1
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      fontWeight: 500,
      fontSize: "1.25rem"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== title) {
    t3 = <Typography component="h3" sx={t2}>{title}</Typography>;
    $[2] = title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      display: "flex",
      flexDirection: "column",
      gap: 3
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== listItems || $[6] !== title) {
    t5 = listItems.length === 0 ? <Typography sx={{
      color: "neutral.light",
      fontStyle: "italic"
    }}>None</Typography> : listItems.map((item, index) => <Box key={index} sx={{
      display: "flex",
      flexDirection: "row",
      gap: 3
    }}>{title === "Pros" ? <span className="mask-icon mask-icon-check" style={{
        width: "1.5rem",
        height: "1.5rem",
        backgroundColor: palette.primary.main
      }} /> : <span className="mask-icon mask-icon-close" style={{
        width: "1.5rem",
        height: "1.5rem",
        backgroundColor: palette.reds.main
      }} />}<Typography sx={{
        color: "text.primary",
        fontWeight: 400,
        lineHeight: "150%",
        fontVariantNumeric: "lining-nums tabular-nums"
      }}>{item}</Typography></Box>);
    $[5] = listItems;
    $[6] = title;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <Box sx={t4}>{t5}</Box>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t6) {
    t7 = <Box sx={t1}>{t3}{t6}</Box>;
    $[10] = t3;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}